let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Y446")).then(() => parcelRequire('3v3Vj'));